import InsightsOutlined from "@mui/icons-material/InsightsOutlined";

import { EmptyHeadline, EmptyHelper, EmptyWrap } from "./styles";

export const InsightsEmptyState: React.FC = () => (
  <EmptyWrap>
    <InsightsOutlined fontSize="large" />
    <EmptyHeadline>Not enough data to show useful insights</EmptyHeadline>
    <EmptyHelper>
      Try widening the date range or removing some filters.
    </EmptyHelper>
  </EmptyWrap>
);
